import { render, staticRenderFns } from "./TopbarTitle.vue?vue&type=template&id=5bd0ebd3&"
import script from "./TopbarTitle.vue?vue&type=script&lang=ts&"
export * from "./TopbarTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports